<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row class="pa-4">
    <v-col cols="12" class="pa-4" v-if="showTitle">
    <v-card flat>
      <v-card-title>
        Benutzer
        <v-spacer></v-spacer>
        <v-text-field
        v-model="search"
        append-icon="search"
        label="Suche"
        single-line
        hide-details
        ></v-text-field>
      </v-card-title>
    </v-card>
    </v-col>
    <v-col cols="12" xs="12" class="pa-4">
      <v-data-table
          :headers="headers"
          hide-default-footer
          :items="deviceList"
          :search="search"
      >

        <template v-slot:item.name="{ item }">
          <span>
            {{item.name}}
          </span>
        </template>
        <template v-slot:item.guidParent="{ item }">
            <span :style="getCompanyStyle(item)">
              {{item.companyName}}
              <span v-if="!item.companyName" class="handpointer" @click="openCompanyDialog(item)">zuweisen</span>
            </span>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
          >
            edit
          </v-icon>
          <v-icon
              small
              @click="deleteItem(item)"
          >
            delete
          </v-icon>
        </template>
      </v-data-table>

    </v-col>
    <DialogDeleteItem ref="dlgDelete" @doDelete="doDelete"></DialogDeleteItem>
  </v-row>
</template>

<script>
import Vue from 'vue'
import DialogDeleteItem from "../dialogs/DialogDeleteItem";

export default {
  name: 'TableUser',
  props: {
    showTitle: Boolean,
    companyId: String
  },
  components: {DialogDeleteItem},
  methods: {
    deleteItem: function (item) {
      this.$refs.dlgDelete.open({
        type: 'Rolle',
        id: '' + item.guid,
        name: 'Rolle ' + item.name,
        item: item
      })
    },
    doDelete: function (item) {
      console.log('item', item)
      Vue.prototype.$apiRole.deleteItem(item.item.guid, this.reload)
    },
    openCompanyDialog: function (item) {
      console.log('openCompanyDialog', item)
      this.currentDevice = item
      this.$refs.dlgLink.open({
        title: 'Netzwerk zuweisen',
        description: 'Wählen Sie ein Netzwerk'
      })
    },
    onLinkCompany: function (item) {
      console.log('onLinkCompany', item)
      Vue.prototype.$api.linkDeviceToCompany(this.currentDevice.guid, item, this.reload)
    },
    editItem: function (item) {
      if (this.companyId) {
        this.$router.push('/Netzwerke/' + this.companyId + '/Rollen/' + item.guid)
      } else {
        this.$router.push('/Rollen/' + item.guid)
      }
    },
    getHDStyle: function (item) {
      var style = ''
      var prz = (100 / item.diskUsageMax) * item.diskUsageCurrent

      if (prz < 80) {
        style = 'color: green'
      } else {
        style = 'color: orange'
      }
      if (prz > 95) {
        style = 'color: red'
      }
      return style
    },
    getCompanyStyle: function (item) {
      var style = ''
      if (!item.companyName) {
        style = 'color: #aa4444;'
      }
      return style
    },
    reload: function () {
      var reqData = {}
      if (this.companyId != null) {
        reqData.guidParent = this.companyId
      }
      Vue.prototype.$apiRole.loadRoles(reqData, this.onGetData)
    },
    onGetData: function (result) {
      console.log('result', result)
      this.deviceList = result
    }
  },
  data () {
    return {

      currentDevice: null,
      search: null,
      headers: [
        {text: 'Name', align: 'left', value: 'name'},
        {text: 'Firma', value: 'guidParent'},
        {text: 'Beschreibung', value: 'comment'},
        {text: 'Aktion', value: 'action'}
        /*{text: 'Erstellt', value: 'created'},
        {text: 'Kommentar', value: 'comment'}
         */
      ],
      deviceList: []
    }
  },
  mounted () {
    var cmp = this
    this.$nextTick(() => {
      cmp.reload()
    })
  }
}
</script>

<style scoped>

</style>
